import { render, staticRenderFns } from "./PerformanceTemplate.vue?vue&type=template&id=6cd8de86&scoped=true"
import script from "./PerformanceTemplate.vue?vue&type=script&lang=js"
export * from "./PerformanceTemplate.vue?vue&type=script&lang=js"
import style0 from "./PerformanceTemplate.vue?vue&type=style&index=0&id=6cd8de86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd8de86",
  null
  
)

export default component.exports